import Tooltip from 'primevue/tooltip';
// Custom tooltip directive that supports both hover and focus events.
// PrimeVue's default tooltip only supports one or the other.
export const vTooltipAccessible = {
    ...Tooltip,
    mounted(el, _binding) {
        const target = el;
        if (target.$_ptooltipModifiers?.focus) {
            target.$_accessibleMouseEnterEvent = () => {
                if (!target.matches(':focus')) {
                    target.$_accessibleHoverFocused = true;
                    target.focus();
                }
            };
            target.$_accessibleMouseLeaveEvent = () => {
                if (target.$_accessibleHoverFocused) {
                    target.$_accessibleHoverFocused = false;
                    target.blur();
                }
            };
            el.addEventListener('mouseenter', target.$_accessibleMouseEnterEvent);
            el.addEventListener('mouseleave', target.$_accessibleMouseLeaveEvent);
        }
    },
    beforeUnmount(el) {
        const target = el;
        // Clean up our additional event listeners
        if (target.$_ptooltipModifiers?.focus) {
            if (target.$_accessibleMouseEnterEvent) {
                el.removeEventListener('mouseenter', target.$_accessibleMouseEnterEvent);
            }
            if (target.$_accessibleMouseLeaveEvent) {
                el.removeEventListener('mouseleave', target.$_accessibleMouseLeaveEvent);
            }
        }
    }
};
